const styles = () => ({
  root: {
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    fontSize: 30,
    color: '#414953',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    marginLeft: 17,
  },

  row: {
    width: '100%',
    fontSize: 15,
    margin: '0 0 18px 0',
    lineHeight: '1.4em',
  },

  doubleContainer: {
    flexDirection: 'row',
  },

  double: {
    width: '50%',
  },

  key: {
    color: '#A9B0B8',
    marginBottom: 4,
  },

  value: {
    color: '#414953',
    lineHeight: 1.5,
  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },

  link: {
    color: '#5786D7',
  },

  socialLink: {
    color: '#5786D7',
    width: 18,
    height: 18,
    display: 'block',
    margin: '0 32px 0 0',
  },

  socialBar: {
    width: '100%',
    display: 'flex',
    margin: '0 0 0 0',

    '&:empty': {
      display: 'none',
    },
  },

  person: {
    margin: '0 0 34px 0',
    padding: '0 0 34px 0',
    borderBottom: '1px solid #F3F4F5',
  },

  sep: {
    height: 1,
    background: '#F3F4F5',
    margin: '34px 0',
  },
});

export default styles;
